/**
 * Converte dias ou minutos em uma string legível para o usuário.
 * Regra: 180 dias -> 6 meses | 365 dias -> 1 ano
 * @param {number|string} value - O valor vindo da API
 * @returns {string}
 */
export const formatExpirationTime = (value) => {
  const days = Number(value);
  if (!days || days <= 0) return "";

  if (days >= 365) {
    const years = Math.floor(days / 365);
    return years === 1 ? "1 ano" : `${years} anos`;
  }

  if (days >= 30) {
    const months = Math.floor(days / 30);
    // Especial para o seu caso de 180 dias = 6 meses
    return months === 1 ? "1 mês" : `${months} meses`;
  }

  return days === 1 ? "1 dia" : `${days} dias`;
};